// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b306b422","239":"b35b1b3f","667":"e9fa244f"}[chunkId] + ".chunk.js";
};